import { render, staticRenderFns } from "./ImportDataTable.vue?vue&type=template&id=123d0fb0&scoped=true&"
import script from "./ImportDataTable.vue?vue&type=script&lang=js&"
export * from "./ImportDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ImportDataTable.vue?vue&type=style&index=0&id=123d0fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d0fb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VPagination,VTextField,VToolbar})
